import { Action } from 'redux';
export const GET_MAINPERMIT_CONTENTS = 'sales-message-pages/GET_MAINPERMIT_CONTENTS';
export const GET_MAIN_PERMIT_CONTENTS = 'sales-message-pages/GET_MAIN_PERMIT_CONTENTS';
export const GET_SINGLE_VEHICLE_ENTRY = 'sales-message-pages/GET_SINGLE_VEHICLE_ENTRY';
export const GET_SINGLE_VEHICLE_ENTRY_PAGE = 'sales-message-pages/GET_SINGLE_VEHICLE_ENTRY_PAGE';
export const GET_MULTIPLE_VEHICLE_ENTRY = 'sales-message-pages/GET_MULTIPLE_VEHICLE_ENTRY';
export const GET_MULTIPLE_VEHICLE_ENTRY_PAGE = 'sales-message-pages/GET_MULTIPLE_VEHICLE_ENTRY_PAGE';
export const GET_PERMIT_PAYMENT = 'sales-message-pages/GET_PERMIT_PAYMENT';
export const GET_PERMIT_PAYMENT_PAGE = 'sales-message-pages/GET_PERMIT_PAYMENT_PAGE';
export const GET_PERMIT_PAYMENT_PAYROLL = 'sales-message-pages/GET_PERMIT_PAYMENT_PAYROLL';
export const GET_PERMIT_PAYMENT_PAGE_PAYROLL = 'sales-message-pages/GET_PERMIT_PAYMENT_PAGE_PAYROLL';
export const GET_PAYROLL_AGREEMENT = 'sales-message-pages/GET_PAYROLL_AGREEMENT';
export const GET_PAYROLL_AGREEMENT_PAGE = 'sales-message-pages/GET_PAYROLL_AGREEMENT_PAGE';
export const GET_SCHOOL_ACCOUNT_EXTRA_TEXT = 'sales-message-pages/GET_SCHOOL_ACCOUNT_EXTRA_TEXT';
export const GET_SCHOOL_ACCOUNT_EXTRA_TEXT_PAGE = 'sales-message-pages/GET_SCHOOL_ACCOUNT_EXTRA_TEXT_PAGE';
export const GET_SCHOOL_ACCOUNT_AGREEMENT_TEXT = 'sales-message-pages/GET_SCHOOL_ACCOUNT_AGREEMENT_TEXT';
export const GET_SCHOOL_ACCOUNT_AGREEMENT_TEXT_PAGE = 'sales-message-pages/GET_SCHOOL_ACCOUNT_AGREEMENT_TEXT_PAGE';
export const GET_REVIEW_ORDER = 'sales-message-pages/GET_REVIEW_ORDER';
export const GET_REVIEW_ORDER_PAGE = 'sales-message-pages/GET_REVIEW_ORDER_PAGE';
export const GET_CHECKBOX_AGREEMENT = 'sales-message-pages/GET_CHECKBOX_AGREEMENT';
export const GET_CHECKBOX_AGREEMENT_PAGE = 'sales-message-pages/GET_CHECKBOX_AGREEMENT_PAGE';
export const GET_ORDER_COMPLETE = 'sales-message-pages/GET_ORDER_COMPLETE';
export const GET_NEW_PERMIT_ORDER_COMPLETE = 'sales-message-pages/GET_NEW_PERMIT_ORDER_COMPLETE';
export const GET_ORDER_COMPLETE_PAGE = 'sales-message-pages/GET_ORDER_COMPLETE_PAGE';
export const GET_NEW_PERMIT_ORDER_COMPLETE_PAGE = 'sales-message-pages/GET_NEW_PERMIT_ORDER_COMPLETE_PAGE';
export const UPDATE_MAIN_PERMIT_CONTENTS = 'sales-message-pages/UPDATE_MAIN_PERMIT_CONTENTS';
export const UPDATE_SINGLE_VEHICLE_ENTRY_PAGE = 'sales-message-pages/UPDATE_SINGLE_VEHICLE_ENTRY_PAGE';
export const UPDATE_MULTIPLE_VEHICLE_ENTRY_PAGE = 'sales-message-pages/UPDATE_MULTIPLE_VEHICLE_ENTRY_PAGE';
export const UPDATE_PERMIT_PAYMENT_PAGE = 'sales-message-pages/UPDATE_PERMIT_PAYMENT_PAGE';
export const UPDATE_PERMIT_PAYMENT_PAYROLL = 'sales-message-pages/UPDATE_PERMIT_PAYMENT_PAYROLL';
export const UPDATE_PAYROLL_AGREEMENT_PAGE = 'sales-message-pages/UPDATE_PAYROLL_AGREEMENT_PAGE';
export const UPDATE_REVIEW_ORDER_PAGE = 'sales-message-pages/UPDATE_REVIEW_ORDER_PAGE';
export const UPDATE_CHECKBOX_AGREEMENT_PAGE = 'sales-message-pages/UPDATE_CHECKBOX_AGREEMENT_PAGE';
export const UPDATE_ORDER_COMPLETE_PAGE = 'sales-message-pages/UPDATE_ORDER_COMPLETE_PAGE';
export const UPDATE_NEW_PERMIT_ORDER_COMPLETE_PAGE = 'sales-message-pages/UPDATE_NEW_PERMIT_ORDER_COMPLETE_PAGE';
export const UPDATE_SCHOOL_ACCOUNT_EXTRA_TEXT_PAGE = 'sales-message-pages/UPDATE_SCHOOL_ACCOUNT_EXTRA_TEXT_PAGE';
export const UPDATE_SCHOOL_ACCOUNT_AGREEMENT_TEXT_PAGE =
  'sales-message-pages/UPDATE_SCHOOL_ACCOUNT_AGREEMENT_TEXT_PAGE';

//export const PERSIST_HOMEPAGE = 'home-page/PERSIST_HOMEPAGE';
/**
 * Get Main Permit contents
 */
export interface GetMainPermitContentsAction extends Action<typeof GET_MAINPERMIT_CONTENTS> {
  payload: any;
}

export const getMainPermitContents = (data: any): GetMainPermitContentsAction => ({
  type: GET_MAINPERMIT_CONTENTS,
  payload: data,
});

export const getMainPermitPageContents = () => {
  return {
    type: GET_MAIN_PERMIT_CONTENTS,
  };
};

export interface GetsingleVehicleEntryContentsAction extends Action<typeof GET_SINGLE_VEHICLE_ENTRY> {
  payload: any;
}

export const getsingleVehicleEntryContents = (data: any): GetsingleVehicleEntryContentsAction => ({
  type: GET_SINGLE_VEHICLE_ENTRY,
  payload: data,
});

export const getSingleVehicleContents = () => {
  return {
    type: GET_SINGLE_VEHICLE_ENTRY_PAGE,
  };
};

export interface GetMultipleVehicleEntryContentsAction extends Action<typeof GET_MULTIPLE_VEHICLE_ENTRY> {
  payload: any;
}
export const getMultipleVehicleEntryContents = (data: any): GetMultipleVehicleEntryContentsAction => ({
  type: GET_MULTIPLE_VEHICLE_ENTRY,
  payload: data,
});

export const getMultipleVehicleContents = () => {
  return {
    type: GET_MULTIPLE_VEHICLE_ENTRY_PAGE,
  };
};

export interface GetPermitPaymentContentsAction extends Action<typeof GET_PERMIT_PAYMENT> {
  payload: any;
}
export const getPermitPaymentContents = (data: any): GetPermitPaymentContentsAction => ({
  type: GET_PERMIT_PAYMENT,
  payload: data,
});
export const getPermitPaymentPageContents = () => {
  return {
    type: GET_PERMIT_PAYMENT_PAGE,
  };
};

export interface GetPermitPaymentPayrollContentsAction extends Action<typeof GET_PERMIT_PAYMENT_PAYROLL> {
  payload: any;
}
export const getPermitPaymentPayrollContents = (data: any): GetPermitPaymentPayrollContentsAction => ({
  type: GET_PERMIT_PAYMENT_PAYROLL,
  payload: data,
});
export const getPermitPaymentPagePayrollContents = () => {
  return {
    type: GET_PERMIT_PAYMENT_PAGE_PAYROLL,
  };
};

export interface GetPayrollAgreementAction extends Action<typeof GET_PAYROLL_AGREEMENT> {
  payload: any;
}
export const getPayrollAgreementContents = (data: any): GetPayrollAgreementAction => ({
  type: GET_PAYROLL_AGREEMENT,
  payload: data,
});
export const getPayrollAgreementPage = () => {
  return {
    type: GET_PAYROLL_AGREEMENT_PAGE,
  };
};

export interface GetSchoolAccountAction extends Action<typeof GET_SCHOOL_ACCOUNT_EXTRA_TEXT> {
  payload: any;
}
export const getSchoolAccountContents = (data: any): GetSchoolAccountAction => ({
  type: GET_SCHOOL_ACCOUNT_EXTRA_TEXT,
  payload: data,
});
export const getSchoolAccountPage = () => {
  return {
    type: GET_SCHOOL_ACCOUNT_EXTRA_TEXT_PAGE,
  };
};

export interface GetSchoolAccountAgreementAction extends Action<typeof GET_SCHOOL_ACCOUNT_AGREEMENT_TEXT> {
  payload: any;
}
export const getSchoolAccountAgreementContents = (data: any): GetSchoolAccountAgreementAction => ({
  type: GET_SCHOOL_ACCOUNT_AGREEMENT_TEXT,
  payload: data,
});
export const getSchoolAccountAgreementPage = () => {
  return {
    type: GET_SCHOOL_ACCOUNT_AGREEMENT_TEXT_PAGE,
  };
};

export interface GetReviewOrderAction extends Action<typeof GET_REVIEW_ORDER> {
  payload: any;
}
export const getReviewOrderContents = (data: any): GetReviewOrderAction => ({
  type: GET_REVIEW_ORDER,
  payload: data,
});
export const getReviewOrderPage = () => {
  return {
    type: GET_REVIEW_ORDER_PAGE,
  };
};

export interface GetCheckboxAgreementAction extends Action<typeof GET_CHECKBOX_AGREEMENT> {
  payload: any;
}
export const getCheckboxAgreementContents = (data: any): GetCheckboxAgreementAction => ({
  type: GET_CHECKBOX_AGREEMENT,
  payload: data,
});
export const getCheckboxAgreement = () => {
  return {
    type: GET_CHECKBOX_AGREEMENT_PAGE,
  };
};

export interface GetOrderCompleteAction extends Action<typeof GET_ORDER_COMPLETE> {
  payload: any;
}
export const getOrderCompleteContents = (data: any): GetOrderCompleteAction => ({
  type: GET_ORDER_COMPLETE,
  payload: data,
});

export interface GetNewPermitOrderCompleteAction extends Action<typeof GET_NEW_PERMIT_ORDER_COMPLETE> {
  payload: any;
}
export const getNewPermitOrderCompleteContents = (data: any): GetNewPermitOrderCompleteAction => ({
  type: GET_NEW_PERMIT_ORDER_COMPLETE,
  payload: data,
});

export const getOrderComplete = () => {
  return {
    type: GET_ORDER_COMPLETE_PAGE,
  };
};
export const getNewPermitOrderCompletePage = () => {
  return {
    type: GET_NEW_PERMIT_ORDER_COMPLETE_PAGE,
  };
};
export const updateMainPermitContents = (data: any) => {
  return {
    type: UPDATE_MAIN_PERMIT_CONTENTS,
    payload: data,
  };
};
export const updateSingleVehicleEntryPage = (data: any) => {
  return {
    type: UPDATE_SINGLE_VEHICLE_ENTRY_PAGE,
    payload: data,
  };
};
export const updateMultipleVehicleEntryPage = (data: any) => {
  return {
    type: UPDATE_MULTIPLE_VEHICLE_ENTRY_PAGE,
    payload: data,
  };
};
export const updatePermitPaymentPage = (data: any) => {
  return {
    type: UPDATE_PERMIT_PAYMENT_PAGE,
    payload: data,
  };
};
export const updatePermitPaymentPayroll = (data: any) => {
  return {
    type: UPDATE_PERMIT_PAYMENT_PAYROLL,
    payload: data,
  };
};
export const UpdatePayrollAgreementPage = (data: any) => {
  return {
    type: UPDATE_PAYROLL_AGREEMENT_PAGE,
    payload: data,
  };
};
export const UpdateReviewOrderPage = (data: any) => {
  return {
    type: UPDATE_REVIEW_ORDER_PAGE,
    payload: data,
  };
};
export const UpdateCheckboxAgreementPage = (data: any) => {
  return {
    type: UPDATE_CHECKBOX_AGREEMENT_PAGE,
    payload: data,
  };
};
export const UpdateOrderCompletePage = (data: any) => {
  return {
    type: UPDATE_ORDER_COMPLETE_PAGE,
    payload: data,
  };
};
export const UpdateNewPermitOrderCompletePage = (data: any) => {
  return {
    type: UPDATE_NEW_PERMIT_ORDER_COMPLETE_PAGE,
    payload: data,
  };
};
export const UpdateSchoolAccountExtraTextPage = (data: any) => {
  return {
    type: UPDATE_SCHOOL_ACCOUNT_EXTRA_TEXT_PAGE,
    payload: data,
  };
};
export const UpdateSchoolAccountAgreementTextPage = (data: any) => {
  return {
    type: UPDATE_SCHOOL_ACCOUNT_AGREEMENT_TEXT_PAGE,
    payload: data,
  };
};
export const REFRESH_SALES_MESSAGE_PAGES_STORE = 'sales-message-pages/REFRESH_SALSE_MESSAGE_PAGES_STORE';
export const resetSalesMessageStore = () => {
  return {
    type: REFRESH_SALES_MESSAGE_PAGES_STORE,
  };
};
export interface RefreshSalesMessagePageAction extends Action<typeof REFRESH_SALES_MESSAGE_PAGES_STORE> {}

export type SalesMessagePagesAction =
  | GetMainPermitContentsAction
  | GetsingleVehicleEntryContentsAction
  | GetMultipleVehicleEntryContentsAction
  | GetPermitPaymentContentsAction
  | GetPermitPaymentPayrollContentsAction
  | GetPayrollAgreementAction
  | GetSchoolAccountAction
  | GetSchoolAccountAgreementAction
  | GetReviewOrderAction
  | GetCheckboxAgreementAction
  | GetOrderCompleteAction
  | GetNewPermitOrderCompleteAction
  | RefreshSalesMessagePageAction;
